import geodist from 'geodist';

const distanceCalculationInMeter = (lat1, lon1, lat2, lon2) => geodist(
  { lat: lat1, lon: lon1 },
  { lat: lat2, lon: lon2 },
  { exact: true, unit: 'meters' },
);

export default distanceCalculationInMeter;
